import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box sx={{ p: 3, textAlign: "center" }}>
      <Typography>© 2023 All rights reserved by Triton REI Group </Typography>
    </Box>
  );
};

export default Footer;
